import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import * as commonActionCreators from '../../../actions/common';
let allActionCreators = Object.assign({}, commonActionCreators);



class Header extends React.Component {
  
  static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  toggleInvite() {
    this.props.commonOpenInvite();
  }

  homeNav() {
    this.props.commonSetLastVisited(0);
    setTimeout(() => {
      this.context.router.push('/');
    }, 50);
  }

  render() {
    return <div className='Header'>
      <div className='headerIcon' onClick={::this.homeNav}>
        <img src='/img/dallas2020/assets/icon1.svg' />
      </div>
      <div className='inviteWrapper' onClick={::this.toggleInvite}>
        Invite a friend
      </div>
    </div>
  }
}
export default Header;

function mapStateToProps(state) {
  return {
    common: state.common,
  };
}

export const HeaderContainer = connect(
  mapStateToProps,
  allActionCreators
)(Header);


// WEBPACK FOOTER //
// ./src/components/views/header/Header.jsx